import { SxProps } from '@mui/material'
import { availibleThemes, fontSizes } from '../../../config/material-theme.config'
import { IA11Y } from '../../../interfaces/A11Y'

export const copyrightStyles = (a11y: IA11Y): SxProps => ({
  color: a11y.theme === availibleThemes.LIGHT ? 'secondary.contrastText' : 'white',
  fontSize: fontSizes.default.xs,
})
